import { NgModule, APP_INITIALIZER } from '@angular/core';

import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { APP_ROUTES } from './app-routing.module';
import { environment } from 'src/environments/environment';
import { SharedModule } from './shared/shared.module';
import { InterceptorService } from './core/services/interceptor/interceptor.service';
import { HomeModule } from './home/home.module';
import { ReportsModule } from './reports/reports.module';
import { NotificationsModule } from './notifications/notifications.module';
import { ProfileModule } from './profile-home/profile.module';
import { FacsModule } from './facs/facs.module';
import { EditFacModalModule } from './shared/components/edit-fac-modal/edit-fac-modal.module';
import { PropertiesModule } from './properties/properties.module';
import { DistributionQueueModule } from './distribution-queue/distribution-queue.module';
import { TeamManagementModule } from './team-management/team-management.module';
import { initializationFactory } from './initialization-factory';
import { ApplicationInitializeService } from './core/services/application-initialize-service/application-initialize.service';
import { ErrorsPagesModule } from './errors-pages/errors-pages.module';
import { NotfoundExeptionsComponent } from './notfound-exeptions/notfound-exeptions.component';
import { ProductsModule } from './products/product-register/products.module';
import { ParticipantsModalComponent } from './shared/components/participants-modal/participants-modal.component';
import { ProductSheetModule } from './products/product-sheet/product-sheet.module';
import { BrokerCalendarModule } from './broker-calendar/broker-calendar.module';
import { CompanyConfigurationModule } from './company-configuration-list/company-configuration-list.module';
import { ProductGalleryModule } from './products/product-gallery/product-gallery.module';
import { BrokerProfileModule } from './profile/broker-profile/broker-profile.module';
import { HelperCenterComponent } from './helper-center/helper-center.component';
import { UserPreferencesModule } from './user-preferences/user-preferences.module';
import { LeadCampaignModule } from './lead-campaign/lead-campaign.module';
import { DashboardQueueModule } from './dashboard-queue/dashboard-queue.module';
import {LegacyLogoutModule} from './legacy-logout/legacy-logout.module';
import { MatPaginatorIntl } from '@angular/material';
import { CustomPaginator } from './shared/functions/CustomPaginatorConfiguration';
import { ActionHistoryQueueModule } from './action-history-queue/action-history-queue.module';
import { DashboardReportsModule } from './dashboard-reports/dashboard-reports.module';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function getEnvVar(key: string) {
  const win = typeof window === 'undefined' ? null : window as any;
  const env = win && win.env
    ? win.env
    : process.env;

  return env ? env[key] : '';
}

@NgModule({
  declarations: [
    AppComponent,
    NotfoundExeptionsComponent,
    HelperCenterComponent
  ],
  imports: [
    UserPreferencesModule,
    ProductsModule,
    SharedModule,
    HomeModule,
    ReportsModule,
    ProfileModule,
    FacsModule,
    PropertiesModule,
    ProductSheetModule,
    ProductGalleryModule,
    DistributionQueueModule,
    ActionHistoryQueueModule,
    TeamManagementModule,
    CompanyConfigurationModule,
    ErrorsPagesModule,
    HttpClientModule,
    BrowserAnimationsModule,
    BrowserModule.withServerTransition({ appId: 'lpsCrm' }),
    RouterModule.forRoot(APP_ROUTES),
    TransferHttpCacheModule,
    NotificationsModule,
    EditFacModalModule,
    TranslateModule.forRoot({
      defaultLanguage: 'pt-br',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrokerCalendarModule,
    BrokerProfileModule,
    LeadCampaignModule,
    DashboardQueueModule,
    DashboardReportsModule,
    LegacyLogoutModule
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializationFactory,
      deps: [ApplicationInitializeService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true
    },
    {
      provide: 'google_tag_manager_id', useValue: getEnvVar('google_tag_manager_id')
    },
    { provide: MatPaginatorIntl, useValue: CustomPaginator() }
  ],
  entryComponents: [ParticipantsModalComponent],
})
export class AppModule {
}